import axios from 'axios';


const api = new axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
});

export default {
    async searchCompetences(search) {
        try {
            return api.get(`/competences/search?q=${search}`).then(response => response.data);
        } catch (e) {
            throw e
        }
    },
    // for admin
    async getCompetencesForAdmin(excludeHidden) {
        try {
            return api.get(`/api/competences?exclude_hidden=${excludeHidden}`);
        } catch (e) {
            throw e
        }
    },
    // for catalog
    async getCompetences() {
        try {
            return api.get(`/competences`);
        } catch (e) {
            throw e
        }
    },
    async createCompetence(data) {
        return api.post('/competence', data).then(response => response.data)
            .catch(error => console.log(error.response.data));
    },
    async updateCompetence(competenceId, data) {
        try {
            return api.put(`/competence/${competenceId}`, data).then(response => response.data)
        } catch (e) {
            throw e
        }
    },
    async deleteCompetence(competenceId) {
        try {
            return api.delete(`/competence/${competenceId}`).then(response => response.data);
        } catch (e) {
            throw e
        }
    },
    async hideCompetence(competenceId) {
        try {
            return api.patch(`/competence/${competenceId}/hide`);
        } catch (e) {
            throw e
        }
    },
    async showCompetence(competenceId) {
        try {
            return api.patch(`/competence/${competenceId}/show`);
        } catch (e) {
            throw e
        }
    },

    async searchSkills(competenceId, search) {
        try {
            return api.get(`/competence/${competenceId}/skills/search${search}`).then(response => response.data);
        } catch (e) {
            throw e
        }
    },
    async getSkills() {
        return api.get('/skills').then(response => response.data);
    },

    async createSkill(data) {
        return api.post('/skill', data).then(response => response.data);
    },
    async updateSkill(skillId, data) {
        return api.put(`/skill/${skillId}`, data).then(response => response.data);
    },
    async deleteSkill(skillId) {
        return api.delete(`/skill/${skillId}`).then(response => response.data);
    },

    async getCatalog(data) {
        try {
            return api.post(`/api/catalog/`, data);
        } catch (e) {
            throw e
        }
    },

    async searchCommonEvents(search) {
        try {
            return await api.get(`/dict/commonEvents/search?q=${search}`);
        } catch (e) {
            throw e
        }
    },

    async getIDP(pernumber, years) {
        try {
            if (window.IDP.role || window.IDP.role === 'employee') {
                return await axios.get(`/api/employee/${pernumber}/idp?years=${years.join('_')}`);
            } else {
                return await axios.get(`/employee/idp?years=${years.join('_')}`);
            }
        } catch (e) {
            throw e
        }
    },

    async getEmployeeSidebar() {
        try {
            return await axios.get(`/employee`);
        } catch (e) {
            throw e
        }
    },

    async getProviders() {
        try {
            return await axios.get(`/dict/provider`);
        } catch (e) {
            throw e
        }
    },
    async createOrUpdateProvider(data) {
        try {
            return await api.post(`/admin/providers/create` ,data);
        } catch (e) {
            throw e
        }
    },
    async deleteProvider(data) {
        try {
            return await axios.post(`/admin/providers/delete`, data);
        } catch (e) {
            throw e
        }
    },

    async getLearningActivity(activityType, activityId, pernumber, year) {
        const query = pernumber && year ? `pernumber=${pernumber}&year=${year}`: '';
        try {
            return await axios.get(`/api/activity/${activityType}/${activityId}?${query}`);
        } catch (e) {
            throw e
        }
    },

    async getLearningActivities(pernumbers, year) {
        const query = pernumbers && year ? `pernumbers=${pernumbers.join(',')}&year=${year}`: '';
        try {
            return await axios.get(`/api/employees/idps?${query}`);
        } catch (e) {
            throw e
        }
    },

    async hrTemplates() {
        try {
            return api.get(`/hr/templates`).then(response => {
                return {
                    data: {
                        data: response.data
                    }
                };
            });
        } catch (e) {
            throw e
        }
    },

    async getTemplate(templateId) {
        try {
            return await axios.get(`/hr/template/${templateId}`);
        } catch (e) {
            throw e
        }
    },

    async createWish(data) {
        try {
            return await axios.post('/api/wishes/create', data);
        } catch (e) {
            throw e
        }
    },

    async editWish(data) {
        try {
            return await axios.post('/api/wishes/edit', data);
        } catch (e) {
            throw e
        }
    },

    async deleteWish(data) {
        try {
            return await axios.post('/api/wishes/delete', data);
        } catch (e) {
            throw e
        }
    },

    async massDeleteWishes(data) {
        try {
            return await axios.post('/api/wishes/mass/delete', data);
        } catch (e) {
            throw e
        }
    },

    createCommonEvent(data) {
        try {
            return axios.post('/api/activity/create', data);
        } catch (e) {
            throw e
        }
    },

    async editCommonEvent(data) {
        try {
            return await axios.post('/api/activity/edit', data);
        } catch (e) {
            throw e
        }
    },

    async createIndividualEvent(data) {
        try {
            return await axios.post('/api/individual/create', data);
        } catch (e) {
            throw e
        }
    },

    assignCatalogEvent(data) {
        try {
            return axios.post('/api/catalog/assign', data);
        } catch (e) {
            throw e
        }
    },

    assignLearningActivity(laId) {
        try {
            return axios.post(`/api/learning-activity/${laId}/assign`);
        } catch (e) {
            throw e
        }
    },

    completeLearningActivity(laId) {
        try {
            return axios.post(`/api/learning-activity/${laId}/complete`);
        } catch (e) {
            throw e
        }
    },

    deleteLearningActivity(laId) {
        try {
            return axios.post(`/api/learning-activity/${laId}/delete`);
        } catch (e) {
            throw e
        }
    },

    rejectLearningActivity(laId) {
        try {
            return axios.post(`/api/learning-activity/${laId}/reject`);
        } catch (e) {
            throw e
        }
    },

    cancelLearningActivity(laId) {
        try {
            return axios.post(`/api/learning-activity/${laId}/cancel`);
        } catch (e) {
            throw e
        }
    },

    async editIndividualEvent(data) {
        try {
            return await axios.post('/api/individual/edit', data);
        } catch (e) {
            throw e
        }
    },

    async moveToGroup(laId, group, data) {
        try {
            return await axios.post(`/api/learning-activity/${laId}/move/${group}`, data);
        } catch (e) {
            throw e
        }
    },

    async sendToApprove() {
        try {
            return await axios.post(`/employee/idp/approval`);
        } catch (e) {
            throw e
        }
    },

    async agreeIDP(role, pernumber, year) {
        try {
            return await axios.post(`/${role}/employee/${pernumber}/idp/agree?year=${year}`);
        } catch (e) {
            throw e
        }
    },

    async massIDPActivityAgreement(role, data) {
        try {
            return await axios.post(`/${role}/mass/activity/agreement`, data);
        } catch (e) {
            throw e
        }
    },

    async massIDPAgreement(role, data) {
        try {
            return await axios.post(`/${role}/mass/idp/agreement`, data);
        } catch (e) {
            throw e
        }
    },

    async downloadFile(fileId) {
        try {
            return await axios.get(`/api/file/${fileId}/download`)
        } catch (e) {
            throw e
        }
    },

    async deleteFile(fileId) {
        try {
            return await axios.get(`/api/file/${fileId}/delete`)
        } catch (e) {
            throw e
        }
    },

    async setFileViewed(fileId) {
        try {
            return await axios.get(`/api/file/${fileId}/view`)
        } catch (e) {
            throw e
        }
    },

    async getActivityFiles(laId) {
        try {
            return await axios.get(`/api/learning-activity/${laId}/files`)
        } catch (e) {
            throw e
        }
    },

    async getActivityComments(laId) {
        try {
            return await axios.get(`/api/learning-activity/${laId}/comments`)
        } catch (e) {
            throw e
        }
    },

    async export(pernumber) {
        try {
            return await axios.get(`/api/employee/${pernumber}/export`)
        } catch (e) {
            throw e
        }
    },

    async uploadFiles(data) {
        try {
            return await axios.post(`/api/file/upload`, data)
        } catch (e) {
            throw e
        }
    },

    async readComment(id) {
        try {
            return await axios.get(`/api/comment/${id}/read`)
        } catch (e) {
            throw e
        }
    },

    async massComment(data) {
        try {
            return await axios.post(`/api/activity/mass/comment`, data)
        } catch (e) {
            throw e
        }
    },

    async setActivityDeadline(id, data) {
        try {
            return await axios.post(`/api/learning-activity/${id}/deadline`, data)
        } catch (e) {
            throw e
        }
    },

    async massActivityChangeStatus(data) {
        try {
            return await axios.post(`/api/activity/mass/status`, data)
        } catch (e) {
            throw e
        }
    },

    async getAssignments(role, activityId, hrId, year) {
        let query = year ? `year=${year}` : '';
        try {
            return await axios.get(`/api/${role}/activity/${activityId}/employee/search?${role}_id=${hrId}&${query}`);
        } catch (e) {
            throw e
        }
    },

    async getEmployeesFio() {
        try {
            return await axios.get(`/api/user/fios`)
        } catch (e) {
            throw e
        }
    },

    // Admin api calls
    async getEmployeesList(data) {
        try {
            return api.post(`/api/employees/list`, data);
        } catch (e) {
            throw e
        }
    },
    async createEmployee(data) {
        try {
            return api.post(`/admin/employee/create`, data);
        } catch (e) {
            throw e
        }
    },

    async editEmployee(pernumber, data) {
        try {
            return api.post(`/admin/employee/edit/${pernumber}`, data);
        } catch (e) {
            throw e
        }
    },

    async deleteEmployee(pernumber) {
        try {
            return api.get(`/admin/employee/delete/${pernumber}`);
        } catch (e) {
            throw e
        }
    },

    async createHr(data) {
        try {
            return api.post(`/admin/hrs/create`, data);
        } catch (e) {
            throw e
        }
    },

    async deleteHrLink(data) {
        try {
            return api.post(`/admin/hrs/delete`, data);
        } catch (e) {
            throw e
        }
    },

    async createManager(data) {
        try {
            return api.post(`/admin/managers/create`, data);
        } catch (e) {
            throw e
        }
    },

    async deleteManagerLink(data) {
        try {
            return api.post(`/admin/managers/delete`, data);
        } catch (e) {
            throw e
        }
    },

    async createFunctionalManager(data) {
        try {
            return api.post(`/admin/fmanagers/create`, data);
        } catch (e) {
            throw e
        }
    },

    async deleteFunctionalManagerLink(data) {
        try {
            return api.post(`/admin/fmanagers/delete`, data);
        } catch (e) {
            throw e
        }
    },

    // Admin Matrix calls
    async getMatrixActivitiesList(data) {
        try {
            return api.post(`/api/matrix/list`, data);
        } catch (e) {
            throw e
        }
    },
    async changeMatrixActivityStatus(id, status) {
        try {
            return api.get(`/api/matrix/${id}/change-status?status=${status}`);
        } catch (e) {
            throw e
        }
    },

    async getMatrixCatalogList() {
        try {
            return api.get(`/api/matrix/catalog-list`);
        } catch (e) {
            throw e
        }
    },

    async createMatrixActivity(data) {
        try {
            return api.post(`/api/matrix/create`, data);
        } catch (e) {
            throw e
        }
    },

    async editMatrixActivity(id, data) {
        try {
            return api.post(`/api/matrix/${id}/edit`, data);
        } catch (e) {
            throw e
        }
    },

    async importMatrixFromExcel(data) {
        try {
            return api.post(`/api/matrix/import`, data);
        } catch (e) {
            throw e
        }
    },
}
